import {Link as RouterLink} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Illustration} from 'shells/illustrations/illustration';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import styles from './chatbot-report-empty-state.module.css';

export const VARIANT = {
    Onboarding: 'onboarding',
    NoConversations: 'no-conversations',
} as const;

export type Variant = (typeof VARIANT)[keyof typeof VARIANT];

interface Props {
    variant: Variant;
    hasError?: boolean;
}

export function ChatbotReportEmptyState(props: Props) {
    if (props.variant === VARIANT.Onboarding) {
        return (
            <div className='py-64'>
                <Stack spacing={24} alignItems='center' justifyContent='center'>
                    <div className='background-info-bg br-16 pad-32 flex justify-center align-center'>
                        <Illustration src='chatbot-onboarding/add-chatbot-horizontal' width={340} />
                    </div>
                    <Body color='dark' size='large' isBold={true}>
                        Get started with your chatbot
                    </Body>
                    <div className={styles['text-container']}>
                        <Body textAlign='center'>
                            Set up and enable your chatbot today to never miss a visitor. Answer
                            questions in real time, turn conversations into conversions, and track
                            your chatbot's performance with chatbot report
                        </Body>
                    </div>
                    <Link
                        // @ts-expect-error
                        as={RouterLink}
                        to='/inbox/settings/chat'
                        variant='button-primary'
                        size='big'
                        onClick={async (e: React.MouseEvent) => {
                            e.preventDefault();
                            await analyticsClient.track(
                                analyticsClient.EVENTS.TRACK_ONBOARDING_BUTTON_CLICKED_FROM_CR
                            );
                            appHistory.push('/inbox/settings/chat');
                        }}
                    >
                        Go to Chat settings
                    </Link>
                </Stack>
            </div>
        );
    }

    return (
        <div className='py-64 pos-relative'>
            <Stack spacing={24} alignItems='center' justifyContent='center'>
                {props.hasError && (
                    <div className='pos-absolute top-0'>
                        <FlashBanner type='error' hasBorder={true}>
                            Oops! Something went wrong when generating the report. Please try again
                            later.
                        </FlashBanner>
                    </div>
                )}
                <div className='background-info-bg br-16 pad-32 flex justify-center align-center'>
                    <Illustration src='chatbot-onboarding/chatbot-no-conversations' width={290} />
                </div>
                <Body color='dark' size='large' isBold={true}>
                    No conversations yet
                </Body>
                <div className={styles['text-container']}>
                    <Body textAlign='center'>
                        Your chatbot is active. Explore chat settings to customize your chat
                        responses.
                    </Body>
                </div>
                {/* @ts-expect-error */}
                <Link as={RouterLink} to='/inbox/settings/chat' variant='button-primary' size='big'>
                    Go to Chat settings
                </Link>
            </Stack>
        </div>
    );
}
